import { useState } from 'react';

import { JsonTree as JsonEditableTree } from 'react-editable-json-tree';

import { customButtons, styleMap } from './constants';

type JsonTreeProps = {
  data: Record<string, any>; // data can be any object with string keys and any value
  readOnly: boolean;
  onUpdate?: (data: any) => void; // function to handle updates, takes updated data as argument
};

const JsonTree = ({ data, readOnly, onUpdate }: JsonTreeProps) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  // Ensure data is always a valid object
  const validData = data && typeof data === 'object' ? data : {};

  const handleNodeStyle = (
    _: any,
    __: any,
    ___: any,
    ____: any,
    dataType: string | number,
  ) => {
    return styleMap[dataType] || styleMap.String;
  };

  const handleBeforeAddAction = (key: string) => {
    return new Promise((resolve, reject) => {
      // Reject if key is empty or only whitespace
      if (!key || !key.trim()) {
        reject();

        return;
      }

      if (Object.keys(validData).includes(key.trim())) {
        // Reject if key already exists
        setErrorMessage('Key already exists');
        reject();

        return;
      }

      setErrorMessage(null);
      resolve(true);
    });
  };

  const onUpdateData = (updatedData: any) => {
    setErrorMessage(null);
    onUpdate?.(updatedData);
  };

  return (
    <div className="json-tree-container">
      <JsonEditableTree
        data={validData}
        readOnly={readOnly}
        getStyle={handleNodeStyle}
        {...customButtons}
        onFullyUpdate={onUpdateData}
        beforeAddAction={handleBeforeAddAction}
      />
      {errorMessage && (
        <p className="text-red-5 text-sm mt-1">{errorMessage}</p>
      )}
    </div>
  );
};

export default JsonTree;
